/**
 * Recovery for stale lazy-loaded chunks after a redeploy.
 *
 * After a Vite rebuild, `dashboard-Xxxx.js` becomes `dashboard-Yyyy.js`.
 * Users with the old `index.html` still in memory get a 404 when they
 * navigate to a lazy route. Vite emits `vite:preloadError` for exactly
 * this case — we handle it by reloading the page so the browser fetches
 * the new `index.html` (no-cache header in nginx.conf) and the new chunk
 * URLs come with it. Auth cookies survive the reload, so the user lands
 * back where they were.
 *
 * Guard against infinite reload loops: if the new bundle is also broken
 * (race during deploy, CDN cache lag), we let the error surface after one
 * attempt instead of looping until the tab freezes.
 */

const CHUNK_RELOAD_KEY = 'sb_chunk_reload_attempt'
const RELOAD_GUARD_MS = 10_000

export function setupChunkErrorRecovery(): void {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()

    const lastAttempt = sessionStorage.getItem(CHUNK_RELOAD_KEY)
    const now = Date.now()
    if (lastAttempt && now - Number(lastAttempt) < RELOAD_GUARD_MS) {
      console.error(
        'chunk_reload_already_attempted',
        'New bundle still failing — surfacing error instead of looping.',
      )
      return
    }

    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
    window.location.reload()
  })
}
